export class IssuesProformablesFilterComponentsValues {
    conform: number;
    createDateFrom: string;
    createDateTo: string;
    commonArea: number;
    portal: string;
    floor: string;
    door: string;
    csiteId: number;
}
